import { addInsurancePageTranslations } from './AddInsurancePage/translations';
import { editInsurancePageTranslations } from './EditInsurancePage/translations';
import {
  rteErrorReviewPageTranslations,
  processingTranslations,
} from './Processing/translations';
import { reviewInsurancePageTranslations } from './ReviewInsurancePage/translations';
import { subscriberPageTranslations } from './SubscriberPage/translations';

export const resources = {
  en: {
    ...addInsurancePageTranslations.en,
    ...editInsurancePageTranslations.en,
    ...processingTranslations.en,
    ...reviewInsurancePageTranslations.en,
    ...rteErrorReviewPageTranslations.en,
    ...subscriberPageTranslations.en,
  },
  es: {
    ...addInsurancePageTranslations.es,
    ...editInsurancePageTranslations.es,
    ...processingTranslations.es,
    ...reviewInsurancePageTranslations.es,
    ...rteErrorReviewPageTranslations.es,
    ...subscriberPageTranslations.es,
  },

  ru: {
    ...editInsurancePageTranslations.ru,
    ...processingTranslations.ru,
    ...rteErrorReviewPageTranslations.ru,
    ...subscriberPageTranslations.ru,
  },
  ht: {
    ...editInsurancePageTranslations.ht,
    ...processingTranslations.ht,
    ...rteErrorReviewPageTranslations.ht,
    ...subscriberPageTranslations.ht,
  },
  km: {
    ...editInsurancePageTranslations.km,
    ...processingTranslations.km,
    ...rteErrorReviewPageTranslations.km,
    ...subscriberPageTranslations.km,
  },
  pt: {
    ...addInsurancePageTranslations.pt,
    ...editInsurancePageTranslations.pt,
    ...processingTranslations.pt,
    ...reviewInsurancePageTranslations.pt,
    ...rteErrorReviewPageTranslations.pt,
    ...subscriberPageTranslations.pt,
  },
  bn: {
    ...addInsurancePageTranslations.bn,
    ...editInsurancePageTranslations.bn,
    ...processingTranslations.bn,
    ...reviewInsurancePageTranslations.bn,
    ...rteErrorReviewPageTranslations.bn,
    ...subscriberPageTranslations.bn,
  },
  ja: {
    ...addInsurancePageTranslations.ja,
    ...editInsurancePageTranslations.ja,
    ...processingTranslations.ja,
    ...reviewInsurancePageTranslations.ja,
    ...rteErrorReviewPageTranslations.ja,
    ...subscriberPageTranslations.ja,
  },
  ko: {
    ...addInsurancePageTranslations.ko,
    ...editInsurancePageTranslations.ko,
    ...processingTranslations.ko,
    ...reviewInsurancePageTranslations.ko,
    ...rteErrorReviewPageTranslations.ko,
    ...subscriberPageTranslations.ko,
  },
  ro: {
    ...addInsurancePageTranslations.ro,
    ...editInsurancePageTranslations.ro,
    ...processingTranslations.ro,
    ...reviewInsurancePageTranslations.ro,
    ...rteErrorReviewPageTranslations.ro,
    ...subscriberPageTranslations.ro,
  },
  zh: {
    ...addInsurancePageTranslations.zh,
    ...editInsurancePageTranslations.zh,
    ...processingTranslations.zh,
    ...reviewInsurancePageTranslations.zh,
    ...rteErrorReviewPageTranslations.zh,
    ...subscriberPageTranslations.zh,
  },
};
